module.exports = __webpack_public_path__ + "static/media/Level-2.b880f0fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Level-2.svg
// module id = 1307
// module chunks = 0